/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import AceEditor from 'react-ace';

import Button from '../../juristec-ui/core/Button';
import ActionsGroup from '../../juristec-ui/core/ActionsGroup';

// Import AceEditor modes and themes
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/theme-monokai';

import { verifySqlCode } from '../../juristec-ui/utils/validators/inputTextValidators';

import {
  MainContainer,
  EditorContainer,
} from './styled/ChangeDatabaseQuery.styled';

interface ChangeDatabaseQueryProps {
  /**
   * Function to close the modal
   * @type {Function}
   *  @returns {void}
   */
  close: () => void;
  /**
   * Function to submit the new query
   * @type {Function}
   *  @param {string} query - The new SQL query
   *  @returns {void}
   */
  submit: (query: string) => void;
  /**
   * Function to get the current query
   * @type {Function}
   *  @returns {Promise<string>} - The current SQL query
   */
  getQuery: () => Promise<string>;
  /**
   * Dialect of the SQL database (e.g. "Postgresql", "MySQL")
   */
  dialect: 'Postgresql' | 'MySQL' | 'Oracle' | 'TransactSQL';

}

const ChangeDatabaseQuery = ({
  close, submit, getQuery, dialect,
}: ChangeDatabaseQueryProps) => {
  const [inputDBCode, setInputDBCode] = useState({ value: '', errorMsg: '' });

  const handleDBCode = (e: string) => {
    setInputDBCode({ value: e, errorMsg: verifySqlCode(dialect, e.trim()) });
  };

  const handleSubmit = () => {
    submit(inputDBCode.value);
  };
  useEffect(() => {
    (async () => {
      const query = await getQuery();
      setInputDBCode({ value: query, errorMsg: verifySqlCode(dialect, query) });
    })();
  }, [getQuery]);

  return (
    <MainContainer>
      <span>
        Informe a nova query SQL para atualizar a fonte de dados.
        Certifique-se que a estrutura do resultado seja compatível com a atual.
      </span>
      <EditorContainer>
        <AceEditor
          mode="sql"
          theme="monokai"
          fontSize={14}
          lineHeight={19}
          scrollMargin={[0, 0]}
          enableLiveAutocompletion
          enableBasicAutocompletion
          enableSnippets
          tabSize={4}
          showPrintMargin
          showGutter
          highlightActiveLine
          value={inputDBCode.value}
          style={{ width: '100%', height: '100%' }}
          onChange={handleDBCode}
          name="CodeEditor"
          editorProps={{ $blockScrolling: true }}
          placeholder="SELECT ... FROM ... WHERE ..."
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            enableMobileMenu: true,
            showLineNumbers: true,
          }}
        />
      </EditorContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={
            !(inputDBCode.value.length > 0 && inputDBCode.errorMsg.length === 0)
          }
        >
          Editar
        </Button>
      </ActionsGroup>
    </MainContainer>
  );
};

export default ChangeDatabaseQuery;
